import { render, staticRenderFns } from "./UpdateContentLesson.vue?vue&type=template&id=2e6018a0"
import script from "./UpdateContentLesson.vue?vue&type=script&lang=js"
export * from "./UpdateContentLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports